@if (!active) {
    <div>
        <div class="row w-100 pt-3 text-center row-title">
            <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Activer la 5G</div>
        </div>
        <div class="row w-100 p-3">
            <div class="row w-100 pl-3">Pour bénéficier de la 5G, vous devez disposer d'un smartphone compatible.</div>
            <div class="space-top mb-4">
                <span class="bold-label-text">Quel téléphone utilisez-vous ? * :</span>
                <div class="space-top">
                    <select name="phoneModel" class="custom-select" (change)="setSelectedType($event)">
                        <option value="">Choisissez votre smartphone</option>
                        @for (phoneModel of phoneModels; track phoneModel) {
                            <option value="{{ phoneModel.model }}">{{ phoneModel.model }}</option>
                        }
                    </select>
                </div>
                @if (displayTypeError) {
                    <div class="row w-100 ml-2 form-text error-message">Ce champ est obligatoire. Merci de choisir votre
                        téléphone dans la liste.
                    </div>
                }
            </div>
            @if (priceDetails?.price != 'Gratuite') {
                <div class="row w-100 pl-3 mb-4">Cette option vous sera
                    facturée {{ priceDetails?.price }} @if (priceDetails?.perMonth) {
                        <span class="pr-1 pl-1">par mois</span>
                    } en plus de votre forfait habituel.
                </div>
            }
            <div class="col-12 w-100 pt-2 text-center">
                <div class="cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                    </button>
                </div>
                <p class="pt-2">
                    Si votre smartphone n'est pas compatible 5G, l'activation de la 5G peut entraîner <strong>des
                    perturbations sur le réseau 4G.</strong>
                </p>
            </div>
        </div>
    </div>
}

@if (active) {
    <div>
        <div class="row w-100 pt-3 text-center">
            <div class="bold-text blue-color align-content-center w-100 pb-3">Désactiver la 5G</div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100">
                Je souhaite désactiver la 5G
                <br><br>
            </div>
            <div class="w-100 text-center cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                </button>
            </div>
        </div>
    </div>
}
